module.exports = __webpack_public_path__ + "img/5-5.16bedc63.jpg";